var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path, _rect11, _path2, _path3, _rect12, _text, _rect13, _rect14, _path4, _path5, _rect15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIosAddHomeStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 250,
    viewBox: "0 0 420 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgAdd",
    x1: 0,
    y1: 0,
    x2: 420,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sheetAdd",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentAdd",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BE2E"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 419,
    height: 249,
    rx: 18,
    fill: "url(#bgAdd)",
    stroke: "#3E3E3E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 24,
    width: 320,
    height: 202,
    rx: 26,
    fill: "#101010"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 34,
    width: 300,
    height: 182,
    rx: 20,
    fill: "url(#sheetAdd)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 48,
    width: 272,
    height: 26,
    rx: 13,
    fill: "#D9DFE8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 57,
    width: 88,
    height: 8,
    rx: 4,
    fill: "#9AA4B6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 84,
    width: 272,
    height: 116,
    rx: 16,
    fill: "#E6EAF0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 94,
    width: 252,
    height: 18,
    rx: 9,
    fill: "#D1D8E2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 118,
    width: 252,
    height: 18,
    rx: 9,
    fill: "#D9E0E9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 142,
    width: 252,
    height: 18,
    rx: 9,
    fill: "#D2D9E3"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 166,
    width: 252,
    height: 24,
    rx: 12,
    fill: "#101010"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 171,
    width: 236,
    height: 14,
    rx: 7,
    fill: "url(#accentAdd)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 174,
    width: 16,
    height: 8,
    rx: 2,
    fill: "#3D2E00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106 178L110 174L114 178",
    stroke: "#3D2E00",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 174,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#3D2E00",
    opacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M338 177L384 208",
    stroke: "#E6F680",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M376 198L392 212L374 214",
    fill: "#E6F680"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 196,
    width: 112,
    height: 34,
    rx: 12,
    fill: "#101010",
    opacity: 0.78
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 217,
    textAnchor: "middle",
    fill: "#E6F680",
    fontSize: 14,
    fontFamily: "Arial, sans-serif",
    fontWeight: 700
  }, "ADD TO HOME")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 44,
    width: 72,
    height: 34,
    rx: 11,
    fill: "#111111"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 49,
    width: 62,
    height: 24,
    rx: 8,
    fill: "#2A2A2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M310 54V66",
    stroke: "#E6F680",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M305 59L310 54L315 59",
    stroke: "#E6F680",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 302.5,
    y: 64.5,
    width: 15,
    height: 6.5,
    rx: 2.2,
    stroke: "#E6F680",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosAddHomeStep);
export default __webpack_public_path__ + "static/media/ios-add-home-step.d7f6a772b5162bd090717ba4f3291481.svg";
export { ForwardRef as ReactComponent };